import { Tooltip as SCTooltip, TooltipContent, TooltipProvider, TooltipTrigger, TooltipArrow } from '../ui/tooltip'

export function Tooltip({ text, children }) {
	return (
		<TooltipProvider delayDuration={100}>
			<SCTooltip>
				<TooltipTrigger asChild>{children}</TooltipTrigger>
				<TooltipContent side='bottom' className='tw-bg-black tw-text-white tw-py-2 tw-px-3 tw-rounded-md'>
					<TooltipArrow className='ytw-fill-current tw-text-black' width={15} height={5} />
					{text}
				</TooltipContent>
			</SCTooltip>
		</TooltipProvider>
	)
}
